import React, {Component} from "react";
import "./AllAdminHeader.css"
import {FormattedMessage} from "react-intl";

class AllAdminHeader extends Component {

    render() {
        return (
            <thead>
            <tr>
                <th>
                    <FormattedMessage id="app.admin-all-header.name"
                                      defaultMessage="Name"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.admin-all-header.username"
                                      defaultMessage="Username"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.admin-all-header.role"
                                      defaultMessage="User Role"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.admin-all-header.phone"
                                      defaultMessage="Contact No"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.admin-all-header.actions"
                                      defaultMessage="Actions"
                                      description=""/>
                </th>
            </tr>
            </thead>
        )
    }

}
export  default AllAdminHeader;


// WEBPACK FOOTER //
// ./src/components/Admin/AllAdminUsers/AllAdminHeader/AllAdminHeader.js